import {zDateTime} from '@brunata-angular/util';
import {z} from 'zod';

const meterSchema = z
    .object({
        meterId: z.number(),
        locationMeterId: z.number(),
        placement: z.string().nullable(),
        meterNo: z.string(),
        allocationUnit: z.string(),
    })
    .transform(data => ({
        ...data,
        meterId: data.meterId.toString(),
        locationMeterId: data.locationMeterId.toString(),
    }));

const meterValueSchema = z.object({
    readingDate: zDateTime.nullable(),
    value: z.number().nullable(),
    unit: z.number(),
    readingMethod: z.string().nullable().optionalUntilDeployed('AGI-20301'),
});

export const readingSchema = z.object({
    meter: meterSchema,
    meterValue: meterValueSchema,
});

export type Reading = z.infer<typeof readingSchema>;
